<nz-alert
    nzType="error"
    [nzMessage]="'ERRORS.FORBIDDEN_MESSAGE' | translate"
    [nzDescription]="'ERRORS.FORBIDDEN_DESCRIPTION' | translate"
    nzShowIcon
>
</nz-alert>
